// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vFFJ","type":"styles_type__2HwWW","choices":"styles_choices__2IYkB"};